import { render, staticRenderFns } from "./notificationSrv.vue?vue&type=template&id=bbd64196&scoped=true"
import script from "./notificationSrv.vue?vue&type=script&lang=js"
export * from "./notificationSrv.vue?vue&type=script&lang=js"
import style0 from "./notificationSrv.vue?vue&type=style&index=0&id=bbd64196&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbd64196",
  null
  
)

export default component.exports